import axios from "axios";
import { TestCaseResponse, GenerateTestsRequest } from "../types";

const API_BASE_URL = process.env.REACT_APP_API_URL || "/api";

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000, // 60 second timeout for test generation
  headers: {
    "Content-Type": "application/json",
  },
});

export const generateTests = async (
  request: GenerateTestsRequest
): Promise<TestCaseResponse> => {
  const response = await apiClient.post("/generate-tests", {
    apiKey: request.apiKey,
    userStory: request.userStory,
    domain: request.domain,
  });

  return response.data;
};

export const healthCheck = async (): Promise<{
  status: string;
  timestamp: string;
  platform?: string;
}> => {
  const response = await apiClient.get("/health");
  return response.data;
};
